import React from 'react';
import './styles.css';

export const PortfolioItem = ({ src, alt }) => <img className="portfolio-item" src={src} alt={alt} />;
